import {
    apiRequest,
    dependentList,
    dependentActive,
    dependentInactive
} from "../../../../../services/adapters/master/dependentService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", dependentList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", dependentInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", dependentActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository